import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const ProjectFloorplans = () => {
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const { id } = useParams();
  const projectId = id;

  const ImageURL = "https://mithahomesfrontend.pemixcels.com";

  // Fetch Data
  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      setError("Project ID is missing from the URL.");
      return;
    }

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${ImageURL}/api/mainprojectprocess/projectsgetapi/${projectId}`
        );

        if (response.data.success) {
          setProjectData(response.data.data);
          setActiveTab(0);
        } else {
          setError("Failed to fetch project details.");
        }
      } catch (e) {
        setError(`Error loading project: ${e.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [projectId]);

  const handleNextFloorplan = () => {
    setActiveTab((prev) =>
      prev === projectData.floorplans.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrevFloorplan = () => {
    setActiveTab((prev) =>
      prev === 0 ? projectData.floorplans.length - 1 : prev - 1
    );
  };

  // -------------------------------------
  // LOADING
  // -------------------------------------
  if (loading)
    return (
      <div
        style={{
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="spinner"
          style={{
            height: 50,
            width: 50,
            borderRadius: "50%",
            border: "4px solid transparent",
            borderTopColor: "#2563eb",
            borderBottomColor: "#2563eb",
            animation: "spin 1s linear infinite",
          }}
        ></div>
      </div>
    );

  // -------------------------------------
  // ERROR
  // -------------------------------------
  if (error)
    return (
      <div
        style={{
          padding: 16,
          margin: 16,
          backgroundColor: "#ffe4e6",
          border: "1px solid #fecdd3",
          color: "#b91c1c",
          textAlign: "center",
        }}
      >
        <strong>Error:</strong> {error}
      </div>
    );

  // -------------------------------------
  // NO DATA
  // -------------------------------------
  if (!projectData?.floorplans?.length)
    return (
     <>
     </>
    );

  const currentFloorplan = projectData.floorplans[activeTab];

  return (
    <>
      <div style={{ borderRadius: 12 }}>
        {/* TITLE */}
        <div style={{ textAlign: "center"}}>
          <h2
            style={{
              marginBottom: "0px",
              fontSize: "clamp(22px, 3vw, 30px)",
              fontWeight: 600,
              color: "#1f2937",
            }}
          >
            Floor Plans
          </h2>
        
        </div>

        {/* SCROLLING + CENTERED TABS */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            overflowX: "auto",
          }}
        >
          <div
            className="tabs-scroll-container scroll-tabs"
            style={{
              display: "flex",
              gap: "8px",
              marginBottom:'0px',
              padding: "8px 16px",
              scrollbarWidth: "none",
              WebkitOverflowScrolling: "touch",
              scrollSnapType: "x mandatory",
            }}
          >
            {projectData.floorplans.map((floorplan, idx) => (
              <button
                key={idx}
                onClick={() => setActiveTab(idx)}
                className="floorplan-tab"
                style={{
                  flexShrink: 0,
                  padding: "12px 20px",
                  fontWeight: 550,
                  whiteSpace: "nowrap",
                  border: "none",
               
                  fontSize: 15,
                  cursor: "pointer",
                  scrollSnapAlign: "center",
                  backgroundColor:
                    activeTab === idx ? "#e25d26" : "",
                  color: activeTab === idx ? "white" : "black",
           
                }}
              >
                {floorplan.name}
              </button>
            ))}
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div style={{ padding: " 16px" ,paddingTop:"0px"}}>
          <div style={{ maxWidth: 1000, margin: "0 auto" }}>
            {/* FLOORPLAN IMAGE */}
            <div style={{ width: "100%"}}>
              <div
                className="image-wrapper"
                style={{
                  backgroundColor: "#fff",
                  borderRadius: 12,
                  padding: 16,
                  position: "relative",
                  width: "100%",
                  aspectRatio: "16/9",
                }}
              >
                <img
                  src={ImageURL + currentFloorplan.image}
                  alt={currentFloorplan.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "scale-down",
                  }}
                />

                {/* MOBILE NAVIGATION */}
                <div
                  className="nav-container-desktop-hidden"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    right: 0,
                    display: "none",
                    justifyContent: "space-between",
                    padding: "0 16px",
                  }}
                >
                  <button
                    onClick={handlePrevFloorplan}
                    style={{
                      background: "#fff",
                      borderRadius: "50%",
                      border: "none",
                      width: 45,
                      height: 45,
                      cursor: "pointer",
                    }}
                  >
                    ◀
                  </button>

                  <button
                    onClick={handleNextFloorplan}
                    style={{
                      background: "#fff",
                      borderRadius: "50%",
                      border: "none",
                      width: 45,
                      height: 45,
                      cursor: "pointer",
                    }}
                  >
                    ▶
                  </button>
                </div>
              </div>
            </div>

         
          </div>
        </div>
      </div>

      {/* GLOBAL CSS */}
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .scroll-tabs::-webkit-scrollbar { display: none; }

          @media (max-width: 768px) {
            .nav-container-desktop-hidden { display: flex !important; }
            .image-wrapper { aspect-ratio: 4/3 !important; }
          }
        `}
      </style>
    </>
  );
};

export default ProjectFloorplans;
